import { Controller } from "@hotwired/stimulus";
import { debounce } from "lodash-es";

export default class extends Controller {
  static outlets = ["scroll-snap"];

  connect() {
    this.debouncedUpdate = debounce(this.update.bind(this), 100);
    window.visualViewport.addEventListener("resize", this.debouncedUpdate);
    this.update();
  }

  disconnect() {
    window.visualViewport.removeEventListener("resize", this.debouncedUpdate);
  }

  update() {
    const vh = window.visualViewport.height * 0.01;
    this.element.style.setProperty("--vh", `${vh}px`);
    document.querySelector("html").scrollTop = 0;

    if (this.hasScrollSnapOutlet) {
      this.scrollSnapOutlet.update();
    }
  }
}
